import { AxiosResponse } from 'axios';
import apiService from './api';
import {
  WatsonChatResponse,
  WatsonChatDetailResponse,
  WatsonChatQueryParams,
  WatsonChatSynopsisResponse,
  WatsonChatOverviewResponse,
  WatsonChatAnswerResponse,
} from 'shared/types';

const REPORTS_PATH = '/reports';

export const getWatsonChatSessions = (
  params?: WatsonChatQueryParams
): Promise<AxiosResponse<WatsonChatResponse>> => {
  return apiService.get<WatsonChatResponse>(`${REPORTS_PATH}/watson-chat`, params);
};

export const getWatsonChatDetail = (
  sessionId: string
): Promise<AxiosResponse<WatsonChatDetailResponse>> => {
  return apiService.get<WatsonChatDetailResponse>(`${REPORTS_PATH}/watson-chat/${sessionId}/messages`);
};

export const getWatsonChatSynopsis = (
  sessionId: string
): Promise<AxiosResponse<WatsonChatSynopsisResponse>> => {
  return apiService.get<WatsonChatSynopsisResponse>(`${REPORTS_PATH}/watson-chat/${sessionId}/synopsis`);
};

export const getWatsonChatOverview = (
  params?: WatsonChatQueryParams
): Promise<AxiosResponse<WatsonChatOverviewResponse>> => {
  return apiService.get<WatsonChatOverviewResponse>(`${REPORTS_PATH}/watson-chat/overview`, params);
};

export const askWatsonChat = (
  question: string,
  params?: WatsonChatQueryParams
): Promise<AxiosResponse<WatsonChatAnswerResponse>> => {
  return apiService.post<{ question: string } & WatsonChatQueryParams, WatsonChatAnswerResponse>(
    `${REPORTS_PATH}/watson-chat/ask`,
    { question, ...params },
  );
};
